import arePositionsEqual from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/Helpers/arePositionsEqual';
import parseInstancePositions from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/Helpers/parseInstancePositions';
import type { ViewerFieldInfo, ViewerOccurrence } from '@verclam/docx-kit-editor';

const PART_RANK: Readonly<Record<ViewerOccurrence['part'], number>> = Object.freeze({
	body: 0,
	header: 1,
	footer: 2,
});

/**
 * The first occurrence, in document order (body, then header, then footer), of the field with this uuid
 * at these list positions; `null` when the document shows none.
 */
const findViewerOccurrence = (
	fields: readonly ViewerFieldInfo[],
	fieldId: string,
	positions: readonly number[],
): ViewerOccurrence | null => {
	const info = fields.find((candidate) => candidate.id === fieldId);

	if (info === undefined) {
		return null;
	}

	const matching = info.occurrences.filter((occurrence) =>
		arePositionsEqual(parseInstancePositions(occurrence.path), positions),
	);

	return matching.toSorted((left, right) => PART_RANK[left.part] - PART_RANK[right.part])[0] ?? null;
};

export default findViewerOccurrence;
